// Imports
import $ from 'jquery';

initSubscriptionPlaceholder();

function initSubscriptionPlaceholder() {
    const subscriptionArea = '.c-subscription-form-cta';
    const subscriptionInput = $('.c-subscription-form-cta input:text');

    // early return if no component found
    if (!$(subscriptionArea).length) {
        return;
    }

    // add placeholder to input for kentico form
    $(subscriptionInput).attr('placeholder', 'Enter your email address');
}
